import { useCallback, useMemo, useState } from "react"
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { Typography } from "@mui/material";
import { OPTIONS_VARIANTS } from "../../../../utils/structures";
import CheckIcon from '@mui/icons-material/Check';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Styles from './Styles/Order.module.css'

export default function Option(props) {

    const [checked, setChecked] = useState([]);

    const optionIndex = useMemo(() => props.productOptions.findIndex(elem => elem.name === props.option.name), [props.productOptions, props.option])

    const unitsAcum = useMemo(() =>
        props.productOptions[optionIndex] && props.option.isMandatory && props.option.type === OPTIONS_VARIANTS.addUnits ?
            props.productOptions[optionIndex].subOptions.reduce((prev, curr) => prev + curr.units, 0) : 0,
        [props.productOptions, props.option, optionIndex])


    const updateProductOptions = useCallback((subOptionIndex, subOption) => {

        let prevProductOptions = props.productOptions
        //const optionIndex = prevProductOptions.findIndex(elem => elem.option === props.option.name)

        if (optionIndex === -1) {
            if (subOptionIndex === -1) {
                //agrego la opcion y la subopcion
                prevProductOptions = prevProductOptions.concat({
                    elegibleOptions: props.option.elegibleOptions,
                    name: props.option.name,
                    type: props.option.type,
                    subOptions: [subOption]
                })
            }
        } else {
            if (subOptionIndex === -1) {
                //agrego solo la subopcion
                prevProductOptions[optionIndex].subOptions = prevProductOptions[optionIndex].subOptions.concat(subOption)

            } else {
                // elimino la subopcion o la opcion
                if (prevProductOptions[optionIndex].subOptions.length === 1) {
                    prevProductOptions.splice(optionIndex, 1)

                } else {
                    prevProductOptions[optionIndex].subOptions = prevProductOptions[optionIndex].subOptions.filter(elem => elem.name !== subOption.name)
                }
            }
        }

        prevProductOptions = prevProductOptions.filter(option => option.subOptions)
        props.setProductOptions(prevProductOptions)
    }, [optionIndex, props.productOptions, props.option, props.setProductOptions])

    const handleCheck = useCallback(subOption => {
        const subOptionIndex = checked.findIndex(elem => elem.name === subOption.name)
        const newChecked = [...checked]

        subOptionIndex === -1 ? newChecked.push(subOption) : newChecked.splice(subOptionIndex, 1)

        updateProductOptions(subOptionIndex, subOption)
        setChecked(newChecked)
    }, [checked, updateProductOptions])


    const changeUnits = useCallback((subOption, change) => {
        let prevProductOptions = [...props.productOptions]
        const subOptionIndex = props.option.subOptions.findIndex(elem => elem.name === subOption.name)

        if (optionIndex === -1) {
            //agrego la opcion con sus subopciones, copio todo sin usar referencias porque sino se buguean las unidades
            prevProductOptions = prevProductOptions.concat({
                ...props.option,
                subOptions: props.option.subOptions.map(subOption => ({ ...subOption }))
            })
            prevProductOptions[prevProductOptions.length - 1].subOptions[subOptionIndex].units = 1

        } else {
            //tener la suma total de unidades de todas las subopciones de esta subopcino
            const newValue = prevProductOptions[optionIndex].subOptions[subOptionIndex].units + change

            // Si es menor que cero se ignora
            if (newValue >= 0) {

                // No se guarda
                if (!(prevProductOptions[optionIndex].subOptions[subOptionIndex].limit > 0
                    && prevProductOptions[optionIndex].subOptions[subOptionIndex].limit < newValue)) {

                    // Si hay cierta cantidad obligatoria tengo que comprobar eso antes sino lo guardo directo
                    if (props.option.isMandatory) {
                        const newUnitsAcum = unitsAcum + change

                        if (newUnitsAcum <= prevProductOptions[optionIndex].elegibleOptions) {
                            prevProductOptions[optionIndex].subOptions[subOptionIndex].units = newValue
                        }

                    } else {
                        prevProductOptions[optionIndex].subOptions[subOptionIndex].units = newValue
                    }
                }
            }
        }
        props.setProductOptions(prevProductOptions)
    }, [optionIndex, unitsAcum, props.productOptions, props.option, props.setProductOptions])

    const showOption = useMemo(() => {
        if (props.option.type === OPTIONS_VARIANTS.addUnits) {
            return (
                <List sx={{ width: '100%' }}>
                    {props.option.subOptions.map((subOption, subOptionIndex) => {

                        const units = props.productOptions[optionIndex]
                            && props.productOptions[optionIndex].subOptions[subOptionIndex]
                            && props.productOptions[optionIndex].subOptions[subOptionIndex].units ?
                            props.productOptions[optionIndex].subOptions[subOptionIndex].units : 0

                        const removeDisabled = units === 0
                        const addDisabled = props.option.isMandatory && unitsAcum >= props.option.elegibleOptions

                        return (
                            <div key={subOptionIndex}>
                                <ListItem key={subOption.name} sx={{ padding: '10px 0px' }} disabled={removeDisabled && addDisabled}>

                                    <ListItemText primary={subOption.name} secondary={subOption.calories === 0 ? '' : subOption.calories + ' Kal'} />

                                    {subOption.price === 0 ? null : <Typography fontWeight={500}>{"+$" + subOption.price}</Typography>}

                                    <div className={Styles.orderProductActions}>
                                        <IconButton onClick={units === 0 ? null : () => changeUnits(subOption, -1)} disabled={removeDisabled}>
                                            <RemoveIcon />
                                        </IconButton>

                                        <Typography fontWeight={600}>
                                            {units === 0 ? '0' : units + 'x'}
                                        </Typography>

                                        <IconButton onClick={() => changeUnits(subOption, 1)} disabled={addDisabled}>
                                            <AddIcon />
                                        </IconButton>
                                    </div>

                                </ListItem>
                                <Divider />
                            </div>
                        )
                    })}
                </List>
            )

        } else {
            return (
                <List sx={{ width: '100%' }}>
                    {props.option.subOptions.map((subOption, i) => {

                        const labelId = `checkbox-list-label-${subOption.name}`;
                        const isCheck = checked.findIndex(elem => elem.name === subOption.name) !== -1

                        return (
                            <div key={i}>
                                <ListItem key={subOption.name} disablePadding>
                                    <ListItemButton
                                        sx={{ padding: '10px 0px' }}
                                        role={undefined}
                                        onClick={() => handleCheck(subOption)}
                                        dense
                                        disabled={props.option.elegibleOptions < 0 ? false : checked.length >= props.option.elegibleOptions && !isCheck ? true : false}
                                    >
                                        <ListItemIcon>
                                            <Checkbox
                                                edge="start"
                                                checked={isCheck}
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{ 'aria-labelledby': labelId }}
                                            />
                                        </ListItemIcon>

                                        <ListItemText primary={subOption.name} secondary={subOption.calories === 0 ? '' : subOption.calories + ' Kal'} />

                                        {subOption.price === 0 ? null : <Typography fontWeight={500}>{"+$" + subOption.price}</Typography>}

                                    </ListItemButton>
                                </ListItem>
                                <Divider />
                            </div>
                        )
                    })}
                </List>
            )
        }
    }, [changeUnits, checked, handleCheck, optionIndex, props.option, unitsAcum, props.productOptions])

    const isMandatoryText = useMemo(() => {
        if ((props.option.type === OPTIONS_VARIANTS.addUnits && unitsAcum >= props.option.elegibleOptions)
            || (props.option.type === OPTIONS_VARIANTS.selectOption && props.option.elegibleOptions === checked.length)) {

            return <span className={Styles.optionMandatoryFulfilled}><CheckIcon />Obligatoria</span>
        } else {
            return <span className={Styles.optionMandatoryDescription}><WarningAmberIcon />Obligatoria</span>
        }
    }, [checked, props.option, unitsAcum])

    const optionText = useMemo(() => {
        if (props.option.type === OPTIONS_VARIANTS.addUnits) {

            if (props.option.isMandatory) {
                return <Stack direction='row' justifyContent='space-between' alignItems='center'>
                    <Typography>Agrega {props.option.elegibleOptions} unidades </Typography>
                    {isMandatoryText}
                </Stack>

            } else {
                return <Stack direction='row' justifyContent='space-between' alignItems='center'>
                    <Typography>Agrega unidades</Typography>
                    <span className={Styles.optionOptionalDescription}>Opcional</span>
                </Stack>
            }

        } else {
            if (props.option.isMandatory) {
                if (props.option.elegibleOptions === 1) {
                    return <Stack direction='row' justifyContent='space-between' alignItems='center'>
                        <Typography>Elije 1 opción</Typography>
                        {isMandatoryText}
                    </Stack>

                } else {
                    return <Stack direction='row' justifyContent='space-between' alignItems='center'>
                        <Typography>Elije {props.option.elegibleOptions} opciones </Typography>
                        {isMandatoryText}
                    </Stack>
                }

            } else {
                if (props.option.elegibleOptions === 1) {
                    return <Stack direction='row' justifyContent='space-between' alignItems='center'>
                        <Typography>Puedes elegir hasta 1 opción</Typography>
                        <span className={Styles.optionOptionalDescription}>Opcional</span>
                    </Stack>

                } else {
                    return <Stack direction='row' justifyContent='space-between' alignItems='center'>
                        <Typography>Puedes elegir hasta {props.option.elegibleOptions} opciones</Typography>
                        <span className={Styles.optionOptionalDescription}>Opcional</span>
                    </Stack>
                }
            }
        }
    }, [isMandatoryText, props.option])

    return (
        <Stack sx={{ m: 1 }}>
            <Typography variant="h6" fontWeight={700} >{props.option.name}</Typography>

            {optionText}

            {showOption}

        </Stack>
    )
}
